import { buildService } from './decorated-service';
import { Service } from '.';

const ExternalFinancialInstitutionService: Service = buildService(
  '/nasu-svc/service/external-financial-institution'
);

type OnSuccessArgs = {
  authenticationId: string;
  // eslint-disable-next-line
  public_token: string;
  metadata: any;
};

type OnEventArgs = {
  authenticationId: string;
  metadata: any;
  eventname: any;
};
type OnExitArgs = {
  authenticationId: string;
  metadata: any;
  error?: any;
};

type ValidationFailureArgs = {
  bankMissingAddress: boolean;
  bankMissingName: boolean;
  validationZipCodeFail: boolean;
  validationAddressFail: boolean;
  validationFirstNameFail: boolean;
  validationLastNameFail: boolean;
  validationBalanceFail: boolean;
  validationCredentialsFail: boolean;
  validationMFAFail: boolean;
  bankName: string;
};

export const getConfig = async (): Promise<any> =>
  ExternalFinancialInstitutionService.http.get('link/config');

// temp here until handled in the BE getConfig svc call
export const getPlaidLinkToken = async (appID: string): Promise<any> => {
  const linkTokenArgs = {
    clientName: 'NASU Account Selection',
    clientUserId: appID,
    redirectURI: '',
    getLinkToken: true
  };
  return ExternalFinancialInstitutionService.http.post(
    'link/config',
    linkTokenArgs
  );
};

export const onExit = async (args: OnExitArgs): Promise<any> =>
  ExternalFinancialInstitutionService.http.post('link/on-exit', args);

export const onEvent = async (args: OnEventArgs): Promise<any> =>
  ExternalFinancialInstitutionService.http.post('link/on-event', args, {
    transformResponse: resp => resp.text()
  });

export const onLoad = async (): Promise<any> =>
  ExternalFinancialInstitutionService.http.get('link/on-load');

export const onSuccess = async (args: OnSuccessArgs): Promise<any> =>
  ExternalFinancialInstitutionService.http.post('link/on-success', args);

export const validationFailure = async (
  args: ValidationFailureArgs
): Promise<any> =>
  ExternalFinancialInstitutionService.http.post('validation-failure', args, {
    transformResponse: resp => resp.text()
  });
